export default __webpack_public_path__ + "static/media/tea.2f687310.svg";